(function () {
    const lineHeightPx = 21;

/*
    Desired Behavior

    - The sliding mechanism should be seen as a graphically different, but functionally equivalent,
    implementation of checkboxes.
    - The values spanned by the active line are "checked" while all others are not.
*/

    class PlugValuesSlider extends PlugFilterSlider {
        constructor() {
            super();
            /** @type {Filter} */
            this.filterData = JSON.parse(this.querySelector("[data-filter-json]").innerHTML);

            // Jerry-rig fake Cold Hardiness filter values.
            // Uses the query string params to denote active filters.
            if (this.dataset.paramName === 'filter.p.m.custom.cold_hardiness') {
                const sp = new URLSearchParams(location.search);
                sp.getAll('filter.p.m.custom.cold_hardiness').forEach(value => {
                    document.querySelectorAll(`[data-filter-value="${value}"]`).forEach(el => {
                        el.dataset.active = 'true';
                    });
                    document.querySelectorAll(`[value="${value}"]`).forEach(el => {
                        el.setAttribute('checked', true);
                    });
                });
            }
        }

        connectedCallback() {
            this.elements = {
                controlStart: this.querySelector(".plug-control-start"),
                controlEnd: this.querySelector(".plug-control-end"),
                activeLine: this.querySelector(".plug-values-slider__active-line"),
                slider: this.querySelector(".plug-values-slider__slider"),
                hiddenInputs: Array.from(this.querySelectorAll(".plug-values-slider__hidden-inputs > input")),
                listItems: Array.from(this.querySelectorAll(".plug-values-slider__value")),
            };
            this.controlWidth = 16;
            this.preInitLinkToReformat = undefined;
            this.isInitialized = false;
            this.init();
            this.isInitialized = true;
            if (this.preInitLinkToReformat) {
                this.reformatActiveFilter(this.preInitLinkToReformat);
            }
            if (this.elements.slider.dataset.numValidValues !== "1") {
                this.removeListeners = this.initListeners();
            }
        }

        disconnectedCallback() {
            if (this.removeListeners) {
                this.removeListeners();
            }
        }

        init() {
            this.numValues = this.elements.listItems.length;

            if (!this.numValues) {
                this.hideParentBlock();
                return;
            }
            this.showParentBlock();

            this.lineHeight = this.numValues * lineHeightPx;
            this.minValue = 0;
            this.maxValue = this.numValues - 1;
            this.currentStartValue = this.minValue;
            this.currentEndValue = this.maxValue;

            // The idea here is that if someone adjusts the slider, then re-adjusts it before the page
            // has rendered from the first adjustment, we want to cancel that first page render (keeping
            // in mind that this component will be removed during the render process). The caveat here is
            // that we don't want to delay the page fetch/update process, otherwise we would use a standard
            // debounce approach.
            //
            // Each time the emitChange method is called, we insert a new quitEarly object into the
            // following array and pass the object to the "PLUG.collectionFilters.handleChange" function.
            // When/if emitChange is called again, we set the last quitEarly object to true and add a new
            // one to the array.
            //
            // The "handleChange" function triggers a fetch request (for the sections) followed by the
            // page render process. After the fetch request, but before the page render, it checks the
            // value of the quitEarly object it received. If quitEarly is true, it quits early without
            // rendering anything.

            /** @type {{quitEarly: boolean}[]} */
            this.quitEarlyObjects = [];

            let startValue;
            let endValue;
            const activeIndices = this.elements.listItems.reduce((activeIndices, listItem) => {
                if (listItem.dataset.active === "true") {
                    activeIndices.push(Number(listItem.dataset.index));
                }
                return activeIndices;
            }, []);
            if (!activeIndices.length) {
                startValue = 0;
                endValue = this.numValues - 1;
            } else {
                activeIndices.forEach(index => {
                    if (startValue === undefined || index < startValue) {
                        startValue = index;
                    }
                    if (endValue === undefined || index > endValue) {
                        endValue = index;
                    }
                });
            }

            this.setState(startValue, endValue);
        }

        /** @param {HTMLAnchorElement} activeFilterLink */
        reformatActiveFilter(activeFilterLink) {
            if (!this.isInitialized) {
                this.preInitLinkToReformat = activeFilterLink;
                return;
            }
            // compute href
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.delete(this.dataset.paramName);
            activeFilterLink.href = `${location.pathname}?${searchParams.toString()}`;

            // compute text content.
            const activeFilterValues = this.elements.listItems
                .filter(li => li.dataset.active === "true")
                .map(li => li.querySelector(".active-filter-value").textContent);
            if (!activeFilterValues.length) {
                return;
            } else {
                const rangeSpan = activeFilterLink.querySelector(".plug-active-filter-range");
                if (activeFilterValues.length === 1) {
                    rangeSpan.textContent = `${activeFilterValues[0]}`
                } else {
                    rangeSpan.textContent = `${activeFilterValues[0]} - ${activeFilterValues[activeFilterValues.length - 1]}`;
                }
            }
        }

        computeValueUnitPerPx() {
            return this.numValues / this.lineHeight;
        }

        initListeners() {
            const removeStartControlListeners = this.initStartControl();
            const removeEndControlListeners = this.initEndControl();
            return () => {
                removeStartControlListeners();
                removeEndControlListeners();
            };
        }

        updateFormInputs(startValue, endValue) {
            // The entire slider range being selected implies that this component is not applying any filters.
            if (startValue === this.minValue && endValue === this.maxValue) {
                this.elements.hiddenInputs.forEach(input => {
                    input.checked = false;
                });
                return;
            }
            this.elements.hiddenInputs.forEach((input, i) => {
                input.checked = (i >= startValue - .5 && i <= endValue + .5);
            });
        }

        emitChange(startValue, endValue) {
            if (this.quitEarlyObjects.length) {
                this.quitEarlyObjects[this.quitEarlyObjects.length - 1].quitEarly = true;
            }
            this.updateFormInputs(startValue, endValue);
            const parentForm = this.closest("form");
            if (parentForm) {
                this.quitEarlyObjects.push({ quitEarly: false });
                window.PLUG.collectionFilters.handleChange(parentForm, this.quitEarlyObjects[this.quitEarlyObjects.length - 1]);
            } else {
                console.warn("Cannot find parent form.");
            }
        }

        initStartControl() {
            const control = this.elements.controlStart;
            let isDragging = false;
            let valueUnitPerPx = this.computeValueUnitPerPx();
            let dragStartValue;

            const handlePointerUp = () => {
                isDragging = false;
                if (this.currentStartValue !== dragStartValue) {
                    this.emitChange(Math.round(this.currentStartValue), Math.round(this.currentEndValue));
                }
            };

            /** @param {PointerEvent} e */
            const handlePointerMove = (e) => {
                // movementY: Y coordinate delta since last move event.
                if (!isDragging) return;
                if (e.movementY === 0 && e.movementX === 0) {
                    return;
                }
                const currentValue = this.currentStartValue;
                const valueDelta = Math.fround(e.movementY * valueUnitPerPx);
                const newValue = Math.min(this.currentEndValue, Math.max(this.minValue, currentValue + valueDelta));
                this.setState(newValue, undefined);
            };

            /** @param {PointerEvent} e */
            const handlePointerDown = (e) => {
                dragStartValue = this.currentStartValue;
                valueUnitPerPx = this.computeValueUnitPerPx();
                control.setPointerCapture(e.pointerId);
                control.addEventListener("pointerup", handlePointerUp, false);
                control.addEventListener("pointermove", handlePointerMove, false);
                isDragging = true;
            };

            control.addEventListener("pointerdown", handlePointerDown, false);
            control.ondragstart = () => false;

            return () => {
                control.removeEventListener("pointerdown", handlePointerDown, false);
                control.removeEventListener("pointerup", handlePointerUp, false);
                control.removeEventListener("pointermove", handlePointerMove, false);
                control.ondragstart = null;
            };
        }

        initEndControl() {
            const control = this.elements.controlEnd;
            let isDragging = false;
            let valueUnitPerPx = this.computeValueUnitPerPx();
            let dragStartValue;

            const handlePointerUp = () => {
                isDragging = false;
                if (this.currentStartValue !== dragStartValue) {
                    this.emitChange(Math.round(this.currentStartValue), Math.round(this.currentEndValue));
                }
            };

            /** @param {PointerEvent} e */
            const handlePointerMove = (e) => {
                // movementY: Y coordinate delta since last move event.
                if (!isDragging) return;
                if (e.movementY === 0 && e.movementX === 0) {
                    return;
                }
                const currentValue = this.currentEndValue;
                const valueDelta = Math.fround(e.movementY * valueUnitPerPx);
                const newValue = Math.max(this.currentStartValue, Math.min(this.maxValue, currentValue + valueDelta));
                this.setState(undefined, newValue);
            };

            /** @param {PointerEvent} e */
            const handlePointerDown = (e) => {
                dragStartValue = this.currentEndValue;
                valueUnitPerPx = this.computeValueUnitPerPx();
                control.setPointerCapture(e.pointerId);
                control.addEventListener("pointerup", handlePointerUp, false);
                control.addEventListener("pointermove", handlePointerMove, false);
                isDragging = true;
            };

            control.addEventListener("pointerdown", handlePointerDown, false);
            control.ondragstart = () => false;

            return () => {
                control.removeEventListener("pointerdown", handlePointerDown, false);
                control.removeEventListener("pointerup", handlePointerUp, false);
                control.removeEventListener("pointermove", handlePointerMove, false);
                control.ondragstart = null;
            };
        }

        computeMaxStartControlProgress() {
            if (this.endProgress !== undefined) {
                const maxStartDist = this.lineHeight - (this.lineHeight * this.endProgress) - 32;
                return (maxStartDist / this.lineHeight);
            } else {
                return Infinity;
            }
        }

        computeMaxEndControlProgress() {
            if (this.startProgress !== undefined) {
                const maxEndDist = this.lineHeight - (this.lineHeight * this.startProgress) - 32;
                return (maxEndDist / this.lineHeight);
            } else {
                return Infinity;
            }
        }

        setState(startValue, endValue) {
            let startProgress;
            let endProgress;

            if (startValue !== undefined) {
                this.currentStartValue = startValue;
                startProgress = startValue / this.numValues;
                if (startProgress < 0) {
                    startProgress = 0;
                } else {
                    const minPxRemaining = 30;
                    const pxRemaining = this.lineHeight - (this.lineHeight * startProgress);
                    if (pxRemaining < minPxRemaining) {
                        startProgress = (this.lineHeight - minPxRemaining) / this.lineHeight;
                    }
                }
                startProgress = Math.min(startProgress, this.computeMaxStartControlProgress());
                this.startProgress = startProgress;
                this.setControlPosition(this.elements.controlStart, startProgress);
            }

            if (endValue !== undefined) {
                this.currentEndValue = endValue;
                endProgress = 1 - ((endValue + 1 - this.minValue) / this.numValues);
                if (endProgress < 0) {
                    endProgress = 0;
                } else {
                    const minPxRemaining = 30;
                    const pxRemaining = this.lineHeight - (this.lineHeight * endProgress);
                    if (pxRemaining < minPxRemaining) {
                        endProgress = (this.lineHeight - minPxRemaining) / this.lineHeight;
                    }
                }
                endProgress = Math.min(endProgress, this.computeMaxEndControlProgress());
                this.endProgress = endProgress;
                this.setControlPosition(this.elements.controlEnd, endProgress);
            }

            this.elements.listItems.forEach((item, index) => {
                if (index >= this.currentStartValue - .5 && index <= this.currentEndValue + .5) {
                    item.classList.add("is-active");
                } else {
                    item.classList.remove("is-active");
                }
            });

            this.elements.slider.setAttribute("aria-valuetext", `from ${this.currentStartValue} to ${this.currentEndValue}`);
            this.elements.slider.setAttribute("aria-valuenow", `${this.currentStartValue},${this.currentEndValue}`);
            this.setActiveLinePosition(startProgress, endProgress);
        }

        setControlPosition(control, progress) {
            const prop = control.classList.contains("plug-control-start") ? "top" : "bottom";
            control.style[prop] = `calc(${progress * 100}% - 0px)`;
            return progress;
        }

        setActiveLinePosition(progressStart, progressEnd) {
            if (progressStart !== undefined) {
                this.elements.activeLine.style.top = `${progressStart * 100}%`;
            }
            if (progressEnd !== undefined) {
                this.elements.activeLine.style.bottom = `${progressEnd * 100}%`;
            }
        }
    }

    if (!window.customElements.get("plug-values-slider")) {
        window.customElements.define("plug-values-slider", PlugValuesSlider);
    }
})();